const mergeObject = require('hobbit-base/modules/plugins/mergeObject');
const prodConfig = require('./prod');
const appName = require('../package.json').name;

// 只需定义要覆盖线上配置的内容即可
module.exports = mergeObject(prodConfig, {
  site: {
    // publicPath: `https://s.vipkidstatic.com/fe-static/${appName}/test/${process.env.VUE_APP_DRONE || 'default'}/`,
    publicPath: 'https://s.vipkidstatic.com/fe-static/wombat/html/test/',
    outputDir: 'dist/test',
    vconsole: true,
  },
  resources: false,
  log: false,
  custom: {},
});
